var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 30C60 46.5675 46.5675 60 30 60C13.4325 60 0 46.5675 0 30C0 13.4325 13.4325 0 30 0C46.5675 0 60 13.4325 60 30ZM15 40.5H37.5V24C37.5 23.4091 37.3836 22.8239 37.1575 22.2779C36.9313 21.732 36.5998 21.2359 36.182 20.818C35.7641 20.4002 35.268 20.0687 34.7221 19.8425C34.1761 19.6164 33.5909 19.5 33 19.5H10.5V36C10.5 37.1935 10.9741 38.3381 11.818 39.182C12.2359 39.5998 12.732 39.9313 13.2779 40.1575C13.8239 40.3836 14.4091 40.5 15 40.5ZM40.5 34.5L49.5 40.5V19.5L40.5 25.5V34.5Z",
    fill: "#008DFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.4ae8e57804e9f785d492cfbfde8400bb.svg";
export { ForwardRef as ReactComponent };